import React from 'react';
import moment from 'moment';
import { Chip } from '@material-ui/core';
import { Warning } from '@material-ui/icons';
import {
  blue,
  green,
  grey,
  orange,
  red,
  yellow,
} from '@material-ui/core/colors';

import {
  Ticket,
  TicketCategory,
  TicketCategoryLabels,
  TicketPriority,
  TicketPriorityLabels,
  TicketStatus,
  TicketStatusLabels,
} from '../../models/ticket';

export const statusColors: { [key in TicketStatus]: string } = {
  [TicketStatus.OPEN]: blue[700],
  [TicketStatus.IN_PROGRESS]: yellow[800],
  [TicketStatus.WAITING]: orange[700],
  [TicketStatus.RESOLVED]: green[700],
  [TicketStatus.CLOSED]: grey[700],
  [TicketStatus.CANCELLED]: red[700],
};

const priorityColors: { [key in TicketPriority]: string } = {
  [TicketPriority.LOW]: grey[600],
  [TicketPriority.MEDIUM]: blue[700],
  [TicketPriority.HIGH]: orange[800],
  [TicketPriority.CRITICAL]: red[700],
};

export const getStatusChip = (status: TicketStatus) => (
  <Chip
    label={TicketStatusLabels[status] || status}
    style={{
      background: statusColors[status] || grey[700],
      color: '#fff',
      fontWeight: 'bold',
    }}
  />
);

const terminalStatuses = [
  TicketStatus.RESOLVED,
  TicketStatus.CLOSED,
  TicketStatus.CANCELLED,
];

export const isTicketOverdue = (ticket: Ticket): boolean => {
  if (!ticket.dueDate || ticket.completedAt) {
    return false;
  }

  if (terminalStatuses.includes(ticket.status)) {
    return false;
  }

  return moment(ticket.dueDate).endOf('day').isBefore(moment());
};

export const getOverdueChip = () => (
  <Chip
    label="Atrasado"
    icon={<Warning style={{ color: '#fff' }} />}
    style={{ background: red[700], color: '#fff', fontWeight: 'bold' }}
  />
);

export const getPriorityChip = (priority: TicketPriority) => (
  <Chip
    label={TicketPriorityLabels[priority] || priority}
    style={{
      background: priorityColors[priority] || grey[600],
      color: '#fff',
      fontWeight: 'bold',
    }}
  />
);

export const getCategoryChip = (category: TicketCategory) => (
  <Chip
    label={TicketCategoryLabels[category] || category}
    variant="outlined"
    color="primary"
  />
);
